class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.resultsContainer = this.querySelector('[data-results-container]');
    this.debounceTimeout = null;
    this.mouseLeaveTimeout = null;
    this.sectionId = this.getAttribute('data-section-id');
    this.searchButton = this.querySelector('[data-search-button]');
    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    
    this.searchButton.addEventListener('click', this.onSearchClick.bind(this));
    
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.hideResults();
      }
    });

    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.bindCloseButton();
  }

  bindCloseButton() {
    this.closeButton = this.querySelector('[data-close-button]');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        this.hideResults();
        this.input.value = '';
      });
    }
  }

  onInput(event) {
    const searchTerm = event.target.value.trim();
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    if (searchTerm.length === 0) {
      this.hideResults();
      return;
    }

    this.debounceTimeout = setTimeout(() => {
      this.performSearch(searchTerm);
    }, 200);
  }

  onFocus(event) {
    const searchTerm = event.target.value.trim();
    if (searchTerm.length > 0) {
      this.performSearch(searchTerm);
    }
  }

  async performSearch(searchTerm) {
    try {
      const response = await fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[limit_scope]=each&section_id=${this.sectionId}`);
      const text = await response.text();
      const html = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('[data-results-container]')
        .innerHTML;

      this.resultsContainer.innerHTML = html;
      this.showResults();
      this.bindCloseButton();
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  }

  showResults() {
    this.resultsContainer.classList.add('active');
    this.input.setAttribute('aria-expanded', 'true');
  }

  hideResults() {
    this.resultsContainer.classList.remove('active');
    this.input.setAttribute('aria-expanded', 'false');
  }

  onSearchClick() {
    const searchTerm = this.input.value.trim();
    if (searchTerm.length > 0) {
      window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
    }
  }

  onMouseLeave() {
    this.mouseLeaveTimeout = setTimeout(() => {
      this.hideResults();
    }, 300);
  }

  onMouseEnter() {
    if (this.mouseLeaveTimeout) {
      clearTimeout(this.mouseLeaveTimeout);
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
